import CookieHelper from '/@/modules/core/app/helpers/CookieHelper';
import SegmentHelper from '@/integrations/segment/SegmentHelper';

export const HasUrlTrackingSegmentMixin = {
  methods: {
    hasTrackingUrlParam() {
      return !!this.$route.query.tracking;
    },
    hasTrackingCookie(name = 'segment_tracking') {
      return !!CookieHelper.get(name);
    },
    setTrackingCookie(name = 'segment_tracking', value = null) {
      CookieHelper.setWithExpiryInHours(name, value ?? this.$route.query.tracking, 72);
    },
    setTrackingCookieFromObject(name = 'segment_tracking', value = {}) {
      const encodedNewSegmentValues = this.encodeTrackingUrlValue(value);
      this.setTrackingCookie(name, encodedNewSegmentValues);
    },
    getTrackingCookie(name = 'segment_tracking') {
      return CookieHelper.get(name);
    },
    getDecodedTrackingCookieValue(name = 'segment_tracking') {
      return this.hasTrackingCookie(name)
        ? SegmentHelper.decodeTrackingUrlValue(CookieHelper.get(name))
        : null;
    },
    encodeTrackingUrlValue(trackingProperties = {}) {
      return SegmentHelper.encodeTrackingUrlValue(trackingProperties);
    },
    removeTrackingCookie(name = 'segment_tracking') {
      CookieHelper.remove(name);
    },
    appendTrackingCookieValues(name = 'segment_tracking', values = {}) {
      const decodedSegmentValue = this.getDecodedTrackingCookieValue(name);

      if (decodedSegmentValue === null) {
        return;
      }

      const encodedNewSegmentValues = this.encodeTrackingUrlValue({
        ...decodedSegmentValue,
        ...values
      });

      this.setTrackingCookie(name, encodedNewSegmentValues);
    }
  }
};
